import * as React from 'react';

import BaseSvg from '../../BaseSvg';
import { InjectedSvgProps } from '../../hocs';

export default class SidebarAlignRightSvg extends React.PureComponent<InjectedSvgProps> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { className, fillColor } = this.props;

        return (
            <BaseSvg viewBox="0 0 24 24" className={className}>
                <path fill={fillColor} d="M15.5,3V21H3V3H15.5m3-3H0V24H18.5V0Z" />
                <rect fill={fillColor} x="17.59" y="0.5" width="5.91" height="23" />
                <path fill={fillColor} d="M23,1V23H18.09V1H23m1-1H17.09V24H24V0Z" />
            </BaseSvg>
        );
    }
}
